export class ictProjectModel {
    id: string;
    projectName: string;
    contactPerson: string;
    companyName: string;
    contentType: string;
    changesAllowed: boolean;
    restrictedContent: boolean;
    description: string;
    tags: Array<string>;
    purposeOfUsage: string;
    fileName: string;
    fileURL: string;
    clientLogo: string;
    createdBy: string;
    createdOn: any;
    updatedOn: any;
    updatedBy: string;
    organizationId: string;
    organizationName: string;
    approvedBy: string;
    projectId: string;
    isLocked: boolean;
    version: number;
    isDeleted: boolean;
}
